import React from 'react';

const TFJS_Models = () => {
    return (
        <div>TFJS_Models Component</div>
    );
}

export default TFJS_Models;
